import {Component, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {GeneralService} from '../../../../_services/general.service';
import {PreviousUrlService} from '../../../../_services/previous-url.service';
import {ReportsBuildings} from '../../../../_interfaces/reports/reports-buildings';
import {ReportsService} from '../../../../_services/reports.service';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Params} from '@angular/router';
import {User} from '../../../../_interfaces/user';
import {AuthenticationService} from '../../../../_services/authentication.service';
import {ServerResponse} from '../../../../_interfaces/server.response';
import {ApiService} from '../../../../_interceptors/api.service';
import {PageTitleService} from '../../../../_services/page-title.service';
import {environment} from '../../../../../environments/environment';

@Component({
	selector: 'app-reports-closed-buildings-list',
	templateUrl: './reports-buildings-list.component.html',
	styleUrls: ['./reports-buildings-list.component.scss'],
	animations: [routeAnimation]
})

export class ReportsClosedBuildingsListComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	private totalItems: number = 0;
	private currentPage: number = 0;
	private searchString: string = '';
	private isLoading: boolean = false;
	private keepLoading: boolean = false;

	public report_type: string = null;
	public report_id: number = null;
	public report_status: string = '/closed';
	public reportBuildings: ReportsBuildings[] = [];

	private _activatedRouteSubscription: Subscription = null;
	private _authenticationServiceSubscription: Subscription = null;

	@Input() smallWidget: boolean = false;
	@Input() reportEditable: boolean = false;
	public user: User = null;

	constructor(private reportsService: ReportsService,
				private apiService: ApiService,
				private previousUrlService: PreviousUrlService,
				private activatedRoute: ActivatedRoute,
				private authenticationService: AuthenticationService,
				private generalService: GeneralService,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.report_type = params['report_type'];
			this.report_id = parseInt(params['report_id'], 10);

			this.reportsService.getClosedReports(this.report_type, this.report_id).then((data: ServerResponse) => {
				if (typeof data !== 'undefined') {
					if (typeof data[0] !== 'undefined') {
						this.pageTitleService.setTitle(data[0].report_nr + ' | Rapportage gebouwen | ' + environment.webappName);
						this.pageTitleService.setPageTitle(data[0].report_nr);
					}
				}
			});

			this._authenticationServiceSubscription = this.authenticationService.user.first().subscribe(user => {
				this.user = user;
				this.currentPage = 0;
				this.getReportBuildings(false);
			});
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._authenticationServiceSubscription !== null) {
			this._authenticationServiceSubscription.unsubscribe();
		}
	}

	getReportBuildings(append_data: boolean = true) {
		if (!this.isLoading || this.keepLoading) {
			this.isLoading = true;
			this.keepLoading = false;
			this.currentPage++;

			this.reportsService.getClosedReportBuildings(this.report_type, this.report_id, null, {
				start: (this.currentPage - 1) * (this.smallWidget ? this.generalService.itemsPerPageShort : this.generalService.itemsPerPage),
				length: (this.smallWidget ? this.generalService.itemsPerPageShort : this.generalService.itemsPerPage),
				'columns[0][search][value]': this.searchString
			}).then((data: ServerResponse) => {
				if (typeof data !== 'undefined') {
					if (typeof data.recordsTotal !== 'undefined') {
						this.totalItems = data.recordsTotal;
					}
					if (append_data === true) {
						this.reportBuildings.push(...<ReportsBuildings[]>data.data);
					} else {
						this.reportBuildings = <ReportsBuildings[]>data.data;
					}
				}
				this.isLoading = false;
			});
		}
	}

	deleteReportBuilding(report_type: string, report_id: number, building_id: number) {
		this.reportsService.deleteBuilding(report_type, report_id, building_id).then(status => {
			if (status === true) {
				let index = this.reportBuildings.findIndex(data => data.id === building_id);

				if (index !== -1) {
					this.reportBuildings.splice(index, 1);
				}
			}
		});
	}

	search($event) {
		this.searchString = $event;
		this.currentPage = 0;
		this.getReportBuildings(false);
	}
}
